/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin GET /enrollment — enroll user in a course ({@link COPY_CODE_TO_COURSE_REQUESTED}).
 *
 * @file GetCourseService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COPY_CODE_TO_COURSE_REQUESTED,
  COPY_CODE_TO_COURSE_COMPLETED,
  COPY_CODE_TO_COURSE_FAILED
} from '../../../common/constants';

export default class CopyCodeToCourseService extends BaseService {
  constructor() {
    super(COPY_CODE_TO_COURSE_REQUESTED, 'copyCodeToCourseStatus');
  }

  /** GET /courses/section/${sectionCopyCode} */
  handleEvent(eventName, eventData = {}) {
    const { sectionCopyCode } = eventData || {};

    return this.getClient('marin').get(`/courses/section/${sectionCopyCode}`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback } = eventData;

    Framework.getEventManager().publish(COPY_CODE_TO_COURSE_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error, eventData = {}) {
    const { callback } = eventData;

    Framework.getEventManager().publish(COPY_CODE_TO_COURSE_FAILED, error);

    if (typeof callback === 'function') {
      callback(null, error);
    }
  }
}
